// -*- Mode: rjsx -*-
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useHistory } from "react-router-dom";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Slide from '@mui/material/Slide';
import Fade from '@mui/material/Fade';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { CloseResponse, QuestionResponse, DelayResponse, PurchaseResponse } from '..';

import Recall from './Recall.jsx';


import { addSuccess } from '../../../ui';
import { queueCelebrate } from '../../queue';

import { STATUS_AWAITING_MENTOR_APPROVAL } from '../../../data';

export function ResponseOption(props) {
    return (
        <div>
          <ResponseButton {...props} />
          {props.showing === props.type ? props.sheet : '' }
        </div>
    );
}

function ResponseButton (props) {
    const icon = props.showing ? <ArrowBackIcon /> : props.icon;

    if(props.showing && props.showing !== props.type) {
        return (
            <ListItem button onClick={() => props.onClick(props.type) }>
              <ListItemIcon> { props.icon  } </ListItemIcon>
              <ListItemText
                secondary={props.primary} />
            </ListItem>);
    }

    
    return (
        <ListItem button onClick={() => props.onClick(props.type) }>
          <ListItemIcon> { props.showing ? <ArrowBackIcon/> : props.icon }  </ListItemIcon>
          <ListItemText
            primary={props.primary}
            secondary={props.secondary} />
        </ListItem>
    );
}

function shouldShowOptions(user, request) {

//    console.log("request.status: %o", request.status);
    
    // if it's claimed by this current user
    if(user && request.key && request.claimed_by && request.claimed_by.key)
        if(user.key == request.claimed_by.key)
            return true;

    return false;
    

}



function AssignedAssistantResponseOptions(props)  {

    const user = props.user;
    const request = props.request;        
    
    const history = useHistory();
    const [showing, show] = useState(null);    

    let showOptions = shouldShowOptions(user, request);
    const dispatch = useDispatch();
         
    function onResponseSuccess(data) {
//        dispatch(queueCelebrate(data));
        dispatch(addSuccess("Great! Let's see what else we can do."));
        history.push('/queue');
    }


    if(request.status == STATUS_AWAITING_MENTOR_APPROVAL)
        return <Recall request={request} />;
        
    let params = {
        showing: showing,
        request: request,
        onClick: (e) => show(e == showing ? null : e),
        onResponseSuccess: onResponseSuccess
    };
    
    return (
        <Slide in={showOptions}>
          <Box style={{ backgroundColor: "white", borderRadius: 5 }}>

            <List>

              <CloseResponse {...params} />
              <QuestionResponse {...params} />
              <DelayResponse {...params} />
              <PurchaseResponse {...params} />
              
            </List>
          </Box>
        </Slide>
    );

}

function Response(props) {

    const user = useSelector(state => state.hud.user);
    let request = props.request;

    if(user && request.claimed_by && request.claimed_by.key == user.key)
        return <AssignedAssistantResponseOptions request={request} user={user} />;
    
    return null; // <em>Hrm</em>;
}

export default Response;
